<template>
    <div :class="{container: true, noscroll: modalVisable}">
        <div class="header" />
        <div class="section section-1" />
        <div class="section section-2">
            <div class="swiper-container current-wrap">
                <div class="swiper-wrapper">
                    <div class="swiper-slide current-slider">
                        <div class="rolling-item">
                            <div class="item item-1" />
                        </div>
                    </div>
                    <div class="swiper-slide current-slider">
                        <div class="rolling-item">
                            <div class="item item-2" />
                        </div>
                    </div>
                    <div class="swiper-slide current-slider">
                        <div class="rolling-item">
                            <div class="item item-3" />
                        </div>
                    </div>
                    <div class="swiper-slide current-slider">
                        <div class="rolling-item">
                            <div class="item item-4" />
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination current-pagination" />
            </div>
            <img
                class="tip"
                src="../assets/img/h5/tips.png"
            >
        </div>
        <div class="section section-3">
            <img
                v-if="lazyUrlList.section && lazyUrlList.section[1]"
                v-lazy="lazyUrlList.section[1]"
                alt="section-3"
            >
        </div>

        <div class="section section-4">
            <img
                v-if="lazyUrlList.section && lazyUrlList.section[2]"
                v-lazy="lazyUrlList.section[2]"
                alt="section-4"
            >
        </div>

        <div class="section section-5">
            <img
                v-if="lazyUrlList.section && lazyUrlList.section[3]"
                v-lazy="lazyUrlList.section[3]"
                alt="section-5"
            >
        </div>
        <div class="section section-6">
            <img
                v-if="lazyUrlList.section && lazyUrlList.section[4]"
                v-lazy="lazyUrlList.section[5]"
                class="title"
                alt="section-5"
            >
            <lazy-component>
                <div
                    v-for="(item, index) in lazyUrlList.itemTipList"
                    :key="item"
                    class="item"
                    @click="showModal(index)"
                >
                    <img
                        :key="item"
                        :src="item"
                        :alt="item"
                    >
                    <!-- <div
                        :class="{'detail-tip': true, 'special': index === 3}"
                    /> -->
                </div>
            </lazy-component>
        </div>
        <img
            v-if="lazyUrlList.section && lazyUrlList.section[6]"
            :src="lazyUrlList.section[6]"
            class="section section-7"
        >
        <img
            v-if="lazyUrlList.section && lazyUrlList.section[7]"
            v-lazy="lazyUrlList.section[7]"
            class="section section-8"
        >
        <!-- <div class="section section-June">
            <div class="imgbg" />
        </div> -->
        <img
            v-if="lazyUrlList.section && lazyUrlList.section[8]"
            v-lazy="lazyUrlList.section[8]"
            class="section section-9"
        >
        <div
            v-if="lazyUrlList.section && lazyUrlList.section[9]"
            v-lazy="lazyUrlList.section[9]"
            class="section section-10"
        />

        <div
            class="fixed-bar"
            :style="footerBtn"
        >
            <button class="btn" @click="jumpTo"></button>
        </div>
        <div
            :class="{'modal-container': true, active: modalVisable}"
        >
            <div
                :class="{'layer': true, active: modalVisable}"
            />
            <div class="modal" v-if="stageList && stageList.length > 0">
                <div

                    :class="{'modal-content': true, active: modalVisable}"
                >
                    <div class="close-container">
                        <div
                            class="close"
                            @click="closeModal"
                        />
                    </div>
                    <div class="title">
                        {{ stageList[current].desc }}
                        <div class="sub-title">
                            {{ stageList[current].title }}
                        </div>
                    </div>
                    <div
                        ref="scrollContent"
                        v-touch-fix
                        class="scroll-content"
                    >
                        <div
                            v-for="(item, index) in stageList[current].detail"
                            :key="index"
                            class="scroll-item"
                        >
                            <div class="scroll-item-title">
                                {{ item.title }}
                            </div>
                            <ul
                                v-for="(t, idx) in item.content"
                                :key="idx"
                                class="scroll-item-desc"
                            >
                                <li>{{ t }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import touchFix from './touchmoveFix';
import { footerCom } from '../../../uitl/618.js';
import { handleJumpUrl } from '../../../uitl/getParam.js';
import axios from '../../../service/index';
import List from './1.js';

export default {
    name: 'JavaJaGouShiH5',
    directives: {
        touchFix
    },
    mixins: [ footerCom],
    data() {
        return {
            current: 0,
            countDownTime: 0,
            modalVisable: false,
            countText: '',
            selfTop: 0,
            isStart: false,
            // 需要懒加载的图片
            lazyUrlList: {},
            List:List
        };
    },

    mounted() {
        if(location.pathname.indexOf('data_basic_sem_search.html') != -1) {
        } else {
            setTimeout(()=>{
                this.eduPlatTrack('WebView', { page_id: '1qb3', 'test_version':'A版-对照版' });
            },500)
        }
        setTimeout(() => {
             this.renderSwiper();
        }, 1000);
    },
     created() {
        // 大数据课程列表
        let temData  = this.List.data;
        this.stageList = temData ? temData.stageList : [];
        this.lazyUrlList = temData ? temData.lazyUrlh5List : [];
        this.$forceUpdate();
        // axios.get('/kw/adam/ad/detail/newBig-data').then(res => {
        //     let temData  = res.data.data;
        //     this.stageList = temData ? temData.stageList : [];
        //     this.lazyUrlList = temData ? temData.lazyUrlh5List : [];
        //     this.$forceUpdate();
        // }).catch(error => {
        //     console.log(error);
        // });

    },
    methods: {
        handler() {
            console.log('this component is showing');
        },
        startPlay() {
            this.isStart = true;
            this.$refs.javaVideo.play();
        },
        getStepClass(index) {
            return `step step-${index}`;
        },
        gblen(str) {
            var len = 0;
            for (var i = 0; i < str.length; i++) {
                if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
                    len += 2;
                } else {
                    len++;
                }
            }
            return len;
        },
        fixedBody() {
            this.selfTop = document.body.scrollTop || document.documentElement.scrollTop;
            document.body.style.cssText += 'position:fixed;overflow: hidden;height: auto;top: -' + this.selfTop + 'px';
        },
        looseBody() {
            var body = document.body;
            body.style.overflow = 'auto';
            body.style.height = 'auto';
            body.style.position = '';
            document.body.scrollTop = document.documentElement.scrollTop = parseInt(this.selfTop);

        },
        showModal(index) {
            this.fixedBody();

            this.current = index;
            this.modalVisable = true;
            this.$refs.scrollContent.scrollTop = 0;
        },
        jumpTo() {
            if(location.pathname.indexOf('data_basic_sem_search.html') != -1) {
                // this.eduPlatTrack('WebButtonClick', {
                //     'page_id': '1qb3',
                //     'button_name': '领取详细课程大纲'
                // });
                handleJumpUrl(`d247297443df4df383f19cc13917fa1d`);
            } else {
                this.eduPlatTrack('WebButtonClick', {
                    'page_id': '1qb3',
                    'test_version':'A版-对照版',
                    'button_name': '领取详细课程大纲'
                });
                let key = 'b9bbe7ae829f4480bc0d860ebf2b1970';
                handleJumpUrl(key);
            }
        },
        closeModal() {
            this.looseBody();
            this.modalVisable = false;
        },
        renderSwiper() {
            let option = {
                direction: 'horizontal',
                loop: true,
                speed: 500,
                pagination: '.current-pagination',
                paginationType: 'bullets',
                paginationClickable: true,
                autoplayDisableOnInteraction: false,
                autoplay: 3000,
                slidesPerView: 'auto',
                centeredSlides: true,
                spaceBetween: 16,
            };
            if (!document.querySelector('.swiper-slide-duplicate-active')) {
                this.$nextTick(() => {
                    const swiperDom = new Swiper('.swiper-container', option);
                });
            }
        },
    }
};
</script>

<style
    lang='less'
    scoped
>

    .bgUrl(@img) {
        background-image: url('../assets/img/h5/@{img}');
        background-position: top center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .container {
        padding-bottom: 120px;
        background: #003475;
    }

    .header {
        width: 750px;
        height: 843px;
        /* .bgUrl('header.png'); */
        background: url('https://s21.lgstatic.com/growth/activity/20210206/1612583400955.png') top center no-repeat;
        background-size: cover;
    }

    .section {
        width: 750px;

        &.section-June {
            width: 100%;
            height: 1340px;
            padding: 60px 30px 0;
            box-sizing: border-box;
            .imgbg {
                height: 100%;
                border-radius: 4px;
                .bgUrl('monthPlan.png');
                background-size: contain;
            }
        }

        &.section-1 {
            width: 716px;
            height: 1391px;
            margin: 69px auto 0;
            .bgUrl('section-1.png');
        }

        &.section-2 {
            height: 841px;

            /deep/.current-wrap {
                height: 723px;

                .rolling-item{
                    width: 100%;
                    height: 100%;
                    border-radius: .15rem;
                    background-color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .item-1 {
                        .bgUrl('text-bg-1.png');
                    }
                    .item-2{
                        .bgUrl('text-bg-2.png');
                    }
                    .item-3{
                        .bgUrl('text-bg-3.png');
                    }
                    .item-4{
                        .bgUrl('text-bg-4.png');
                    }
                    .item{
                        width: 7.573rem;
                        height: 7.133rem;
                        background-size: contain;
                    }
                }

                .current-slider {
                    width: 9.213rem;
                    height: 8.813rem;
                    padding: 0.32rem;
                    transition: all .3s;
                    box-sizing: border-box;
                }
            }

            /deep/.current-pagination {
                .swiper-pagination-bullet {
                    border-radius: 50%;
                    width: .16rem;
                    height: .173rem;
                    background: #fffdf3;
                    opacity: .5;
                    margin: 0 .093rem;
                    &-active{
                        width: .48rem;
                        height: .173rem;
                        background: #fffdf3;
                        border-radius: 4px;
                        opacity: 1;
                    }
                }
            }

            .tip {
                width: 261px;
                height: 22px;
                float: right;
                margin-right: 62px;
            }
        }
        &.section-3 {
            height: 1015px;

            img {
                height: 946px;
                width: 716px;
                margin: 0 auto;
                display: block;
            }
        }

        &.section-4 {
            height: 1664px;

            img {
                height: 1596px;
                width: 716px;
                margin: 0 auto;
                display: block;
            }
        }

        &.section-5{
            height: 1358px;
            img {
                height: 1269px;
                width: 716px;
                margin: 0 auto;
                display: block;
            }
        }
        &.section-6{
            margin-bottom: 69px;

            .title {
                width: 591px;
                height: 164px;
                margin: 0 auto 41px;
                display: block;
            }

            .item {
                width: 716px;
                margin: 0 auto 4px;
                position: relative;

                img {
                    display: block;
                    width: 100%;
                }

                .detail-tip {
                    width: 151px;
                    height: 74px;
                    position: absolute;
                    right: 36px;
                    top: 46px;
                    .bgUrl('detail-tip.png');

                    &.special {
                        top: 91px;
                    }
                }
            }
        }
        &.section-7{
            height: 3408px;
            margin-bottom: 68px;
            box-sizing: border-box;
            padding: 0 17px;
            /* .bgUrl('section-7.png');
            background-size: contain; */
        }
        &.section-8{
            height: 352px;
            margin-bottom: 68px;
            /* .bgUrl('section-8.png');
            background-size: contain; */
        }
        &.section-9{
            /* height: 3137px; */
            margin-bottom: 79px;
            /* .bgUrl('section-9.png');
            background-size: contain; */
        }
        &.section-10{
            height: 24px;
            .bgUrl('section-10.png');
            background-size: contain;
            margin-bottom: 80px;
        }
    }

    .fixed-bar {
        width: 750px;
        height: 136px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #003475;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 9;
        background-image: url('https://s20.lgstatic.com/growth/activity/20210820/1629442005182.png');
        background-size: cover;
        background-repeat: no-repeat;
        .btn {
            width: 100%;
            height: 100%;
            text-align: center;
            font-size: 32px;
            line-height: 90px;
            border-radius: 90px;
            outline: none;
            background-color:transparent;
            border: none;
        }
    }
    .layer {
        position: fixed;
        z-index: 1;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.6);
         display: none;
        &.active {
            display: block;
        }
    }
    .modal-container {
        /* transition: width 0.4s ease-out, opacity 0.2s ease-in, visibility 0.2s ease-in;
        width: 0;
        height: 1022px;
        visibility: 0;
        opacity: 0;
        &.active {
            opacity: 1;
            visibility: 1;
            width: 400px;
        } */
        /* display: none;
        &.active {
            display: block;
        } */
    }
    .modal {
        position: fixed;
        bottom: 119px;
        z-index: 3;
        display: flex;
        justify-content: center;
        .modal-content {
            width: 750px;
            height: 0;
            opacity: 0;
            transition: height .3s;
            &.active {
                opacity: 1;
                height: 962px;
            }
            background: #fff;
            border-radius: 18px 18px 0 0;
            position: relative;

            margin-right: 45px;
            box-sizing: border-box;
        }

        .close {
            width: 52px;
            height: 52px;
            background: url("../assets/img/h5/modal-close.png") no-repeat center;
            background-size: 42px 42px;
            position: absolute;
            right: 18px;
            top: 18px;
            border-radius: 50%;
        }

        .title {
            margin-top: 82px;
            width: 658px;
            font-size: 32px;
            line-height: 40px;
            margin-bottom: 41px;
            padding-left: 45px;
            font-weight: bold;
            &-dot {
                width: 5px;
                height: 5px;
                border-radius: 5px;
                background: #FA4000;
            }
            .sub-title{
                color: #C69C6D;
                font-size: 26px;
                margin-top: 8px;
            }
        }

        .scroll-content {
            height: 790px;
            overflow-y: scroll;

            .scroll-item {
                font-size: 28px;
                line-height: 36px;
                margin-bottom: 27px;
                &:last-child{
                    margin-bottom: 50px;
                }
            }

            .scroll-item-title {
                margin-bottom: 26px;
                font-weight: bold;
                color: #191F34;
                position: relative;
                padding-left: 47px;
                font-size: 26px;
                line-height: 28px;

                &:before {
                    content: '';
                    width: 8px;
                    height: 8px;
                    background: #C69C6D;
                    border-radius: 8px;
                    position: absolute;
                    left: 25px;
                    top: 11px;
                }
            }
            .scroll-item-desc {
                margin-bottom: 26px;
            }
            li {
                margin-bottom: 20px;
                color: #5E6476;
                font-size: 26px;
                padding-left: 48px;
            }
        }
    }
    /*@supports(padding-top: constant(safe-area-inset-bottom)) or (padding-top: env(safe-area-inset-bottom)) {*/
    /*    .container,.fixed-bar {*/
    /*        margin-bottom: constant(safe-area-inset-bottom);*/
    /*        margin-bottom: env(safe-area-inset-bottom);*/
    /*    }*/

    /*}*/
</style>
